import { type FC } from 'react';
import {
  Gear
} from '@phosphor-icons/react';
import { UiIcon, type UiIconProps } from './UiIcon';

export type UiIconGearProps = Omit<UiIconProps, 'IconComponent'>;

export const UiIconGear: FC<UiIconGearProps> = (props) => {
  return (
    <UiIcon
      IconComponent={Gear}
      {...props}
    />
  );
};
